const loggerMiddleware = store => next => async (action) => { // eslint-disable-line
  // if (process.env.NODE_ENV === 'development') console.log(action)
  next(action)
}

export default loggerMiddleware



// WEBPACK FOOTER //
// ./src/middlewares/loggerMiddleware.js